import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SsWebSocketsService } from './ss-web-sockets.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    SsWebSocketsService,
  ],
})
export class SsWebSocketsModule {
}
